__turbopack_context__.v({
  "inactive": "style-module-scss-module__ZY7Wma__inactive",
  "open-house": "style-module-scss-module__ZY7Wma__open-house",
});
